"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenValueChips = TokenValueChips;
var React = _interopRequireWildcard(require("react"));
var _elevation = require("../../styles/variables/_elevation");
var _Chip = require("../Chip");
var _Tooltip = require("../Tooltip");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function defaultResolveTokenValue(_ref) {
  let {
    token,
    disabled,
    onDismiss
  } = _ref;
  // $FlowFixMe[prop-missing] - assumes token has label and key

  return (
    /*#__PURE__*/
    // $FlowFixMe - assumes token has label and key
    React.createElement(_Tooltip.Tooltip, {
      body: token?.label,
      elevation: _elevation.elevationMenu
    }, /*#__PURE__*/React.createElement(_Chip.Chip
    // $FlowFixMe - assumes token has key
    , {
      key: token?.key,
      onDismiss: _ => onDismiss?.(token),
      dismissable: true,
      semantic: 'primary',
      disabled: disabled
    }, token?.label))
  );
}
function TokenValueChips(props) {
  const {
    values,
    disabled,
    locked,
    onDismiss,
    resolveTokenValue = defaultResolveTokenValue
  } = props;
  return values.map(token => {
    const resolvedTokenValue = resolveTokenValue({
      token,
      onDismiss,
      disabled,
      locked
    });
    return resolvedTokenValue;
  });
}
TokenValueChips.displayName = 'TokenValueChips';